import React from 'react'
import {
  IPercentageRange,
  IProductPriceRange,
} from '@scentregroup/shared/types'
import { displayStringForPriceRange } from '@scentregroup/shared/helpers/product-price'
import NonReturnableText from '@scentregroup/shared/components/non-returnable-text'
import style from './index.module.scss'

const ProductPrice: React.FunctionComponent<
  React.PropsWithChildren<{
    priceRange: IProductPriceRange
    discountedPriceRange?: IProductPriceRange
    discountPercentageRange?: IPercentageRange
    returnable: boolean | undefined
  }>
> = ({
  priceRange,
  discountedPriceRange,
  discountPercentageRange: discountPercentageRange,
  returnable,
}) => {
  return (
    <div>
      <div className={style.pricesWrapper}>
        <div
          className={
            discountPercentageRange ? style.discountedPrice : style.price
          }
        >
          {displayStringForPriceRange(discountedPriceRange ?? priceRange)}
        </div>
        <div className={style.discounts}>
          {discountedPriceRange && (
            <div className={style.originalPrice}>
              {displayStringForPriceRange(priceRange)}
            </div>
          )}
        </div>
      </div>
      <NonReturnableText
        returnable={returnable}
        labelClassname={style.nonReturnableText}
      />
    </div>
  )
}

export default ProductPrice
